import './App.css';
import Todo from './Todo';

function App() {
  return (
    <div className="container-fluid gx-0">
      <Todo/>
    </div>
  );
}

export default App;
